import { render, staticRenderFns } from "./IlluEleves.vue?vue&type=template&id=6305b20f&"
import script from "./IlluEleves.vue?vue&type=script&lang=js&"
export * from "./IlluEleves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports